export type EnumLiteralsOf<T extends object> = T[keyof T]

export const Language = Object.freeze({
  en: 'en',
  ru: 'ru'
})

export type Language = EnumLiteralsOf<typeof Language>
